import { RouterModule, Routes } from '@angular/router';

import {
  MaintainerAuthGuardService,
  ProPlusFeaturesGuardService,
  SubscriptionsAuthGuardService,
} from '@services';

import { BookingOverviewComponent } from './booking-overview/booking-overview.component';
import { BookingWrapperComponent } from './booking-wrapper/booking-wrapper.component';
import { SubscriptionSummaryWrapperComponent } from './subscription-summary-wrapper/subscription-summary-wrapper.component';

export const bookingRoutes: Routes = [
  {
    path: 'booking',
    component: BookingWrapperComponent,
    canActivate: [SubscriptionsAuthGuardService, ProPlusFeaturesGuardService],
  },
  {
    path: 'booking/summary',
    component: SubscriptionSummaryWrapperComponent,
    canActivate: [SubscriptionsAuthGuardService, ProPlusFeaturesGuardService],
  },
  {
    path: 'booking-overview',
    component: BookingOverviewComponent,
    canActivate: [MaintainerAuthGuardService, ProPlusFeaturesGuardService],
  },
];

export const BookingRouting = RouterModule.forChild(bookingRoutes);
